import RoundedRectangle from "./RoundedRectangle";

const MovingColumn = ({ shapesData, numColumns }) => {
  const columns = Array.from({ length: numColumns }, () => []);
  shapesData.forEach((shape, index) => {
    columns[index % numColumns].push(shape);
  });
  return columns;
};

const RoundedRectanglesContainerVertical = ({ shapesData }) => {
  const columns = MovingColumn({ shapesData, numColumns: 3 });

  return (
    <div className={`flex gap-4 gap-x-2 p-4`}>
      {columns.map((column, index) => (
        <div key={index} className="flex flex-col gap-1">
          {column.map((shape, shapeIndex) => {
            return <RoundedRectangle key={shapeIndex} {...shape} />;
          })}
        </div>
      ))}
    </div>
  );
};

const RoundedRectanglesContainerHorizontal = ({ shapesData }) => {
  return (
    <div className={`flex gap-4 gap-x-2 p-4 justify-end`}>
      {shapesData.map((shape, index) => (
        <RoundedRectangle key={index} {...shape} />
      ))}
    </div>
  );
};
export {
  RoundedRectanglesContainerVertical,
  RoundedRectanglesContainerHorizontal,
};
